module.exports = __webpack_public_path__ + "static/media/Karla-Regular.1b55fee6.ttf";